var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 60,
    viewBox: "0 0 68 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2608_33579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8625 14.1696C38.6977 12.9558 37.8252 11.3127 37.4395 10.2629",
    stroke: "#D9102A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5993 33.6965C15.4503 33.1071 12.2628 32.9108 9.03674 33.1077",
    stroke: "#D9102A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41931 1.59322C3.41788 1.3888 4.48801 1.80362 5.43531 2.06519C8.13015 2.80929 11.5669 3.62455 12.9014 6.34662C13.3834 7.32963 13.4231 8.31184 13.4045 9.39869C13.3856 10.4981 13.2518 11.5745 12.6433 12.5074C12.1691 13.2344 11.6213 13.6352 10.7857 13.8765C9.85825 14.1441 8.65086 14.2254 7.85303 13.5348C7.35717 13.1055 6.76477 12.3618 6.55017 11.7344L6.3999 10.7501L7.42001 9.75423L9.88143 9.05261L12.97 9.20992L16.2904 10.5771L19.5532 12.6452C22.3504 14.6343 25.7524 17.5008 25.9987 21.1826C26.0182 21.4732 26.1451 23.5885 25.3551 23.3785",
    stroke: "#D9102A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3119 58.0124L32.8528 45.5278L24.8974 42.3664C24.3276 42.1433 24.0042 41.4969 24.1659 40.8741C25.2054 36.6355 30.0265 21.6355 46.3915 19.4664C46.8689 19.4048 47.3463 19.6662 47.5773 20.12L51.1967 27.2969L65.7981 56.2126C66.322 57.2432 65.3516 58.4278 64.3119 58.0124Z",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2494 54.4161C55.2494 54.4161 53.4096 48.8642 58.3157 41.3951",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2749 51.1109C47.2749 51.1109 46.1329 43.5142 53.4014 32.4483",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4539 48.5109C40.4539 48.5109 38.9764 37.8195 48.3797 22.2462",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4425 45.3648C32.4425 45.3648 31.6395 32.8986 38.8623 21.6399",
    stroke: "#2B363B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2608_33579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopper);
export default __webpack_public_path__ + "static/media/popper.28015e0238233c4d62e2f1884309b76c.svg";
export { ForwardRef as ReactComponent };